import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { rgba } from 'polished';
import styled from 'styled-components';
const Dots = styled.div `
  --dotActiveColour: ${brand.white};
  --dotBgColour: ${rgba(brand.white, 0.5)};
  --dotSize: 8px;
  --dotActiveWidth: ${fluid(39, 107)};

  display: flex;
  align-items: center;
  gap: calc(var(--dotSize) * 2);
  flex-wrap: wrap;
  justify-content: center;
`;
const Dot = styled.span `
  ${transition('background-color, max-width')};

  display: block;
  max-width: var(--dotSize);
  width: var(--dotActiveWidth);
  height: var(--dotSize);
  border-radius: var(--dotSize);
  background-color: var(--dotBgColour);

  &[data-active='true'] {
    background-color: var(--dotActiveColour);
    max-width: var(--dotActiveWidth);
  }
`;
export const DotsStyles = {
    Dot,
    Dots,
};
